import { render, staticRenderFns } from "./BadgesIcon.vue?vue&type=template&id=2929f910&"
import script from "./BadgesIcon.vue?vue&type=script&lang=js&"
export * from "./BadgesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports